module.exports = __webpack_public_path__ + "img/rate2.cae27aa7.png";